import React from 'react';
import { Button, Group, Modal, Stack, Text } from '@mantine/core';
import type { Blocker } from 'react-router-dom';
import { useModalContainer } from '../../../contexts/ModalContainerContext';

/** Above workflow modals (Add task, etc.) so leave is always the top gate. */
export const GANTT_LEAVE_CONFIRM_Z_INDEX = 1200;

interface GanttLeaveConfirmModalProps {
  blocker: Blocker;
  onConfirmLeave?: () => void | Promise<void>;
}

export function GanttLeaveConfirmModal({ blocker, onConfirmLeave }: GanttLeaveConfirmModalProps) {
  const modalContainer = useModalContainer();
  const isBlocked = blocker.state === 'blocked';

  const handleStay = () => {
    if (blocker.state === 'blocked') {
      blocker.reset();
    }
  };

  const handleLeave = async () => {
    if (blocker.state === 'blocked') {
      await onConfirmLeave?.();
      blocker.proceed();
    }
  };

  return (
    <Modal
      opened={isBlocked}
      onClose={handleStay}
      title="Leave the schedule?"
      centered
      closeOnClickOutside={false}
      zIndex={GANTT_LEAVE_CONFIRM_Z_INDEX}
      portalProps={modalContainer ? { target: modalContainer } : undefined}
    >
      <Stack gap="md">
        <Text size="sm">
          You have unsaved schedule edits. They will stay in this browser when you leave — return to
          Tasks and use Save to Server when you are ready.
        </Text>
        <Text size="sm" c="dimmed">
          Use Discard on Tasks if you want to throw away local edits instead.
        </Text>
        <Group justify="flex-end" gap="sm" mt="xs">
          <Button variant="default" onClick={handleStay}>
            Stay here
          </Button>
          <Button variant="filled" onClick={handleLeave}>
            Leave and keep edits
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
